module.exports = __webpack_public_path__ + "img/newsImg15.803f139b.png";